import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useState } from 'react';

interface VSelecInstrumentsProps {
    tipoInicial?: string;
    onTipoChange?: (novoTipo: string) => void;
    error?: boolean
    activeLabel?: boolean
    required?: boolean
}

export const VSelecInstruments = ({ tipoInicial = '', onTipoChange, error = false, activeLabel = true, required }: VSelecInstrumentsProps) => {
    const [tipo, setTipo] = useState(tipoInicial);

    const handleChange = (event: SelectChangeEvent) => {
        const novoTipo = event.target.value as string;
        setTipo(novoTipo);
        if (onTipoChange) {
            onTipoChange(novoTipo);
        }
    };

    const titleText = required ? 'Tipo de Instrumento *' : 'Tipo de Instrumento';

    return (
        <Box width={'100%'}>
            <FormControl fullWidth>
                <InputLabel id='tipo_instrumento_label'>{activeLabel ? titleText : ''}</InputLabel>
                <Select
                    labelId='tipo_instrumento_label'
                    label={activeLabel ? 'Tipo de Instrumento' : ''}
                    value={tipo}
                    onChange={handleChange}
                    error={error}
                >
                    <MenuItem value={'piezometro'} >Piezômetro</MenuItem>
                    <MenuItem value={'indicador'} >Indicador de nível da água</MenuItem>
                    <MenuItem value={'poco'} >Poço de alívio</MenuItem>
                    <MenuItem value={'vazao'} >Medidor de vazão</MenuItem>
                    <MenuItem value={'regua'} >Régua de reservatorio</MenuItem>
                    <MenuItem value={'marco'} >Marco topográfico</MenuItem>
                    <MenuItem value={'re'} >Ré topográfico</MenuItem>
                    <MenuItem value={'base'} >Base da estação total</MenuItem>
                    <MenuItem value={'inclinometro'} >Inclinômetro</MenuItem>
                    <MenuItem value={'pluviometro'} >Pluviômetrico</MenuItem>
                </Select>
            </FormControl>
        </Box>
    );
};
